import { ENGLISH_TEST_TYPE_VAL_LABEL_MAP } from 'data';
import { DocumentMap, IDocumentsList } from '../../../../types';
import ChecklistSection from '../../../atoms/checklist-section';
import Finger, { Status } from '../../../atoms/finger';
import { getVisible, getDocStatus } from '../../../../utilities/documents';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useIsSectionLocked } from '../../../../hooks/useIsSectionLocked';
import { SectionId } from '../../../molecules/Sidebar/types';

interface IProps {
  infoOnly: boolean;
  documents: DocumentMap;
  englishTestType: string;
  englishTestDone: boolean;
  warning?: string;
  onResume: (url: string) => void;
  onClick: (docKey: string, infoOnly: boolean) => void;
}
const getEnglishTestName = (englishTestType = '') => {
  const englishTestName = ENGLISH_TEST_TYPE_VAL_LABEL_MAP[englishTestType]
    ? ENGLISH_TEST_TYPE_VAL_LABEL_MAP[englishTestType]
    : englishTestType;
  return englishTestName.replace(/English Test/gi, '');
};

const EnglishTest = (props: IProps) => {
  const { documents: englishTests, englishTestType, englishTestDone, infoOnly } = props;
  const offer = useSelector((state: ApplicationState) => state.student.offer);
  const isSectionLocked = useIsSectionLocked(SectionId.GENERAL_DOC, offer.status);
  let { warning } = props;

  const visibleDocs = getVisible(englishTests, infoOnly) as IDocumentsList[];

  if (visibleDocs.length === 0) return null;

  const label = englishTestDone
    ? `You stated that you completed the ${getEnglishTestName(englishTestType)} English test`
    : 'You stated that you are going to complete an English test';

  warning =
    !warning && !englishTestDone ? 'Ensure this test is either an IELTS, TOEFL, Peason or Cambrige test' : warning;

  return (
    <ChecklistSection
      label={label}
      edit={() => {
        props.onResume('history/step-4');
      }}
      warning={warning}
    >
      {visibleDocs.map((englishTest: IDocumentsList, index: number) => {
        const { key: docKey, item } = englishTest;
        if (item.status === 'REJECTED') {
          return (
            <Finger
              hideButton={true}
              reason={item.reason}
              key={`english-test-${index}`}
              id={`english-test-${index}`}
              status={Status.Rejected}
              label={`English Test Results ${visibleDocs.length > 1 ? (index > 0 ? index : '') : ''}`}
            />
          );
        } else {
          return (
            <Finger
              key={`english-test-${index}`}
              id={`english-test-${index}`}
              status={getDocStatus(item.status, infoOnly, isSectionLocked)}
              completeLabel={infoOnly ? 'View' : undefined}
              resolveLabel={infoOnly ? 'Please Confirm' : undefined}
              buttonLabel={infoOnly ? 'Please review' : undefined}
              label={`English Test Results ${visibleDocs.length > 1 ? (index > 0 ? index : '') : ''}`}
              onClick={() => props.onClick(docKey, infoOnly)}
            />
          );
        }
      })}
    </ChecklistSection>
  );
};

export default EnglishTest;
